import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { Category } from './../models/category';

@Injectable({
    providedIn: 'root'
})

export class CategoryService {
    controller = 'Category';

    constructor(private base: BaseService) { }

    get(id: number): Observable<ApiObjectData> {
        return this.base.get(id, this.controller + '/GetById');
    }

    gets(): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetAllCategories');
    }

    save(obj: Category) {
        return this.base.save(this.controller + '/CreateCategory', obj);
    }

    remove(id: number) {
        return this.base.remove(this.controller, id);
    }
}